
export class ScriptLoader {
    /**
     * generic load script function
     * @param url {string} the url to the script you want to load
     * @param async {Boolean} get the script asynchronously
     */
    public static loadScript(url: string, async: boolean = false) {

         return new Promise<any>((resolve, reject) => {
            const script = document.createElement('script');
            script.src = url;
            script.async = async;
            script.setAttribute('crossorigin', 'anonymous');
            script.addEventListener('load', resolve, false);
            script.addEventListener('error', reject, false);
            document.getElementsByTagName('head')[0].appendChild(script);
        });
    }

    /**
     * Load external js scripts sequentially
     * @param urls {Array} the urls to the scripts you want to load
     */
    public static loadScripts(urls: Array<string>) {

        /*******************************************************
         * Sequentially execute n loadScript calls.
         * Each iteration checks to see if previous
         * promise (loadScript) has been resolved before calling
         * loadScript with the next url. First iteration uses an empty,
         * immediately resolved promise.
         * ***************************************************** */

        return urls.reduce((promise, url) => {
            return promise.then((result) => {
                return ScriptLoader.loadScript(url, false);
            });
        }, Promise.resolve());
    }
}
